export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_CC_DATA_POINTS':
      return action.payload
    default:
      return state
  }
}
